var KMVP = KMVP || {};
KMVP.contractPlattform = KMVP.contractPlattform || {};

KMVP.contractPlattform.initPageEvents = function() {
    $('.multi-collapse').on("show.bs.collapse", function() {
        var collapseItem = $(this).closest('.contract-list-item');
        var contractId = $(collapseItem).find('.contract-id').find('.js-contractid').text();
        $(collapseItem).find('.contract-list-item-header .js-collapse-icon').removeClass("fa-angle-down");
        $(collapseItem).find('.contract-list-item-header .js-collapse-icon').addClass("fa-angle-up");

        // TODO: do not load a secound time
        KMVP.contractPlattform.getContractEntries(contractId);
    });

    $('.multi-collapse').on("hide.bs.collapse", function() {
        var collapseItem = $(this).closest('.contract-list-item');
        $(collapseItem).find('.contract-list-item-header .js-collapse-icon').removeClass("fa-angle-up");
        $(collapseItem).find('.contract-list-item-header .js-collapse-icon').addClass("fa-angle-down");
    });

    $('.js-request-new-entry input').on('change', function() {
        var inputsChanged = 0;
        $('.js-request-new-entry').find("input[type=text][type!='hidden']").each(function() {
            if ($(this).val().trim() != "") {
                inputsChanged = inputsChanged + 1;
            }
        });

        if (inputsChanged > 0) {
            $('.js-send-request[data-new-contract-request-entry-url]').prop("disabled", false);
        } else {
            $('.js-send-request[data-new-contract-request-entry-url]').prop("disabled", true);
        }
    });

    $('.js-send-request').on('click', function(e) {
        e.preventDefault();

        var form = $('#contractRequestForm');

        if ($(this).data("contract-request-url") != undefined) {
            var contractRequestUrl = $(this).data("contract-request-url");
            form.attr("action", contractRequestUrl);

            if (KMVP.contractPlattform.isValidContractRequest()) {
                form.submit();
            }

        } else if ($(this).data("new-contract-request-entry-url") != undefined) {
            var contractRequestUrl = $(this).data("new-contract-request-entry-url");
            form.attr("action", contractRequestUrl);
            var formData = form.serialize();

            if (!KMVP.contractPlattform.isValidNewContractRequestEntry()) {
                return;
            }

            $.ajax({
                type: "POST",
                url: contractRequestUrl,
                data: formData,
                success: function(data) {
                    $(".js-contract-request-entries").html(data);
                    KMVP.contractPlattform.initContractEntriesForFollowUp();
                    $('.js-request-new-entry input').val('');
                    $('.js-send-request[data-new-contract-request-entry-url]').prop("disabled", true);
                    $('.js-send-request[data-contract-request-url]').prop("disabled", false);
                }
            });
        }
    }),

        $('.js-dropdown-support .dropdown-menu').on('click', function(e) {
            e.stopPropagation();
        }),

        $('.js-cp-dropdown-myaccount').on('mouseenter', function() {
            if ($('.js-cp-dropdown-myaccount-toggle').attr('aria-expanded') == 'false') {
                $('.js-cp-dropdown-myaccount-toggle').click();
            }
        }),

        $('.js-cp-dropdown-myaccount').on('mouseleave', function() {
            if ($('.js-cp-dropdown-myaccount-toggle').attr('aria-expanded') == 'true') {
                $('.js-cp-dropdown-myaccount-toggle').click();
            }
        }),

        $('.js-request-followup-contract').on('click', function(e) {
            var requestFollowUpUrl = $('.js-request-followup-contract').data('request-followup-url');
            var contractId = $('.js-contractid-holder').val();

            if (requestFollowUpUrl && contractId) {
                requestFollowUpUrl = requestFollowUpUrl + "?contractId=" + contractId;
                window.location.href = requestFollowUpUrl;
            }
        }),

        // handling popover for follow up and new contract requests
        $('.js-contract-request-type-popup').popover({
            html: true,
            trigger: 'manual',
            container: "body",
            placement: 'bottom',
            content: function() {
                $return = $(this).attr('data-content');
            }
        }).on("mouseenter", function() {
            var _this = this;
            $(this).popover("show");
            var popoverId = $(this).attr("aria-describedby");
            var $popover = $("#" + popoverId);
            $popover.on("mouseleave", function() {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function() {
            var _this = this;
            setTimeout(function() {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide")
                }
            }, 100);
        }).on("click", function(e) {
            // do not open collapased contracts, if click on follow up request popup
            e.stopPropagation();
        }),

        // build url for switching contract overview pages
        $('.js-contract-overview-url').on('click', function(e) {
            // get data from search header
            var url = $(this).data('contract-overview-url');
            var date = $('.js-filter-section .js-formated-datepicker').val();
            var search = $('.js-filter-section .js-cp-search-input').val();
            var contractStatus = $('.js-on-change-submit').val();
            var newUrl = url.substr(0, url.indexOf('?'));

            // create new url and go to page
            newUrl = newUrl + '?' + "date=" + date + "&search=" + search + "&contractStatus=" + contractStatus;
            window.location.href = newUrl;
        }),

        // pagination handling for both contract overview pages
        $('.js-contract-search-pagination').on('click', '.pagination a', function(e) {
            e.preventDefault();

            var href = $(this).attr("href");
            var page = href.substring(href.lastIndexOf('=') + 1);
            var form = $('.js-contract-search-form');

            form.find('input[name="page"]').val(page);
            form.submit();
        });

};

KMVP.contractPlattform.getActiveContract = function(contractId) {
    if ($(".js-active-contract").length) {
        $.get(KMVP.contractPlattform.activeContractUrl + "?contractId=" + contractId,
            function(data) {
                $(".js-active-contract").html(data);
                KMVP.donutChart.updateCharts();
            }
        );
    }
};

KMVP.contractPlattform.initActiveContractEvents = function() {
    $('.js-active-contracts .js-active-contracts-selected').on('click', function() {
        var contractNumber = $(this).find(".contract-id").html();
        var customerContractNumber = $(this).find(".customer-contract-id").html();

        if (contractNumber && customerContractNumber) {
            KMVP.contractPlattform.getActiveContract(contractNumber)

            var $contractIdDropdown = $(this).closest(".js-active-contracts-selected-container").find(".js-contract-id-dropdown");
            if ($contractIdDropdown.length > 0) {
                $contractIdDropdown.find(".contract-id").html(contractNumber);
                $contractIdDropdown.find(".customer-contract-id").html(customerContractNumber);
            }
        }
    });
};

// Accountmanager handling in contract list selection of footer and header
KMVP.contractPlattform.initActiveContractIds = function() {
    if ($(".js-active-contract-ids-footer").length) {
        var url = $(".js-active-contract-ids-footer").data("active-contract-ids-url");
        $.get(url,
            function(data) {
                $(".js-active-contract-ids-footer").html(data);
                // load account manager for default contractId of select
                var target = $('.js-active-contract-ids-footer .js-contract-account-manager');
                var select = $('.js-active-contract-ids-footer .js-active-contract-ids-selected');
                KMVP.contractPlattform.loadAccountManagerInfo(target, select.val());

                select.on('change', function() {
                    var onChangeTargetFooter = $('.js-active-contract-ids-footer .js-contract-account-manager');
                    var contractNumberFooter = $(this).val();
                    KMVP.contractPlattform.loadAccountManagerInfo(onChangeTargetFooter, contractNumberFooter);
                });

            }
        );
    }

    if ($(".js-active-contract-ids-header").length) {
        var url = $(".js-active-contract-ids-header").data("active-contract-ids-url");
        $.get(url,
            function(data) {
                $(".js-active-contract-ids-header").html(data);
                // load account manager for default contractId of select
                var target = $('.js-active-contract-ids-header .js-contract-account-manager');
                var select = $('.js-active-contract-ids-header .js-active-contract-ids-selected');
                KMVP.contractPlattform.loadAccountManagerInfo(target, select.val());

                select.on('change', function() {
                    var onChangeTargetHeader = $('.js-active-contract-ids-header .js-contract-account-manager');
                    var contractNumberHeader = $(this).val();
                    KMVP.contractPlattform.loadAccountManagerInfo(onChangeTargetHeader, contractNumberHeader);
                });

            }
        );
    }
};

KMVP.contractPlattform.loadAccountManagerInfo = function(target, contractId) {
    $.get(KMVP.contractPlattform.accountManagerForContractUrl + "?contractId=" + contractId,
        function(data) {
            target.html(data);
        }
    );
};

// called when contract request page is loaded
KMVP.contractPlattform.getContractEntriesForFollowUp = function() {
    if ($(".js-contract-request-select").length) {
        var contractId = $('.js-contract-request-select').find(":selected").val();
        var contractEntryId = $('.js-contract-entry-request-id').val();
        $.get(KMVP.contractPlattform.requestContractEntriesUrl + "?contractId=" + contractId + "&contractEntryId=" + contractEntryId,
            function(data) {
                $(".js-contract-request-entries").html(data);
                KMVP.contractPlattform.initContractEntriesForFollowUp();
                $('.js-send-request[data-contract-request-url]').prop("disabled", false);
            }
        );
    }
};

// called when another contract is selected as template
KMVP.contractPlattform.initContractEntriesForFollowUp = function() {
    $(".js-contract-request-select").on('change', function(element) {
        var contractId = $(this).find(":selected").val();
        $.get(KMVP.contractPlattform.requestContractEntriesUrl + "?contractId=" + contractId,
            function(data) {
                $('.js-contract-request-id').val(contractId);
                $(".js-contract-request-entries").html(data);
                KMVP.contractPlattform.initContractEntriesForFollowUp();
            }
        );
    });

    $('.contract-request-entry .article-remove').on('click', function(e) {
        var contractEntry = $(e.target).closest('.contract-request-entry');
        contractEntry.remove();
    })
};

KMVP.contractPlattform.getActiveContractsList = function() {
    if ($(".js-active-contracts .js-active-contracts-list").length) {
        $.get(KMVP.contractPlattform.activeContractsUrl,
            function(data) {
                $(".js-active-contracts-list").html(data);
                KMVP.contractPlattform.initActiveContractEvents();
                var contractId = $('.js-active-contracts-selected-container .js-active-contracts-selected').find(".contract-id").html();
                KMVP.contractPlattform.getActiveContract(contractId);
            }
        );
    }
};


KMVP.contractPlattform.getContractEntries = function(contractId) {
    var insertItem = $('.contract-list .item-contractid_' + contractId);
    if ($(insertItem).length) {
        $.get(KMVP.contractPlattform.entriesUrl + "?contractId=" + contractId + "&searchTerm=" + $('.js-cp-search-input').val(),
            function(data) {
                $(insertItem).html(data);
                KMVP.donutChart.updateCharts();

                var target = $(insertItem).closest('.js-contract-list-item').find('.js-contract-account-manager-overview');
                KMVP.contractPlattform.loadAccountManagerInfo(target, contractId);
            }
        );
    }
};

KMVP.contractPlattform.getLatestOrders = function() {
    if ($(".js-latest-orders").length) {
        $.get(KMVP.contractPlattform.latestOrdersUrl,
            function(data) {
                $(".js-latest-orders").html(data);
                KMVP.tooltips.bindTooltips($('.js-latest-orders'));
            }
        );
    }
};

KMVP.contractPlattform.getOnlineQuotes = function() {
    if ($(".js-online-quotes").length) {
        $.get(KMVP.contractPlattform.onlineQuotesUrl,
            function(data) {
                $(".js-online-quotes").html(data);
                KMVP.tooltips.bindTooltips($('.js-online-quotes'));
            }
        );
    }
};

KMVP.contractPlattform.getExpiredContracts = function() {
    if ($(".js-expired-contracts").length) {
        $.get(KMVP.contractPlattform.expiredContractsUrl,
            function(data) {
                $(".js-expired-contracts").html(data);
            }
        );
    }
};

KMVP.contractPlattform.bindActiveContractPaginationLink = function() {
    $('.pagination a').on('click', function(e) {
        e.preventDefault();

        var href = $(this).attr("href");
        var page = href.substring(href.lastIndexOf('=') + 1);

        var contractId = $(".js-contractid-holder").val();

        $.get(KMVP.contractPlattform.activeContractUrl + "?contractId=" + contractId + "&page=" + page,
            function(data) {
                $(".active-contract").html(data);
                KMVP.donutChart.updateCharts();
            }
        );
    });
};

KMVP.contractPlattform.bindContractAddToCartForm = function() {
    $('.js-contract-calloff').on('click', function(e) {
        e.preventDefault();
        if (!$(e.target).hasClass('disabled')) {
            var form = $(e.target).closest('.js-contract-add-to-cart-form');
            var $calloffContainer = $(e.target).closest('.js-cp-calloff');
            var $quantity = $(form).find('.js-cp-calloff-quantity');

            if (!$quantity.val() || !$.isNumeric($quantity.val())) {
                $($calloffContainer).find('.js-calloff-empty-input-errmsg').removeClass('hide');
            } else {
                $($calloffContainer).find('.js-calloff-empty-input-errmsg').addClass('hide');
                form.ajaxSubmit({
                    beforeSend: function() { $(e.target).addClass('disabled') },
                    success: function(cartResult, statusText, xhr, formElement) {
                        if (typeof resetQuantity !== "undefined") {
                            resetQuantity();
                        }
                        ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, formElement);
                        $($calloffContainer).find('.js-cp-calloff-quantity').val('');
                    },
                    complete: function() { $(e.target).removeClass('disabled') }
                });
            }
        }
    });
};

KMVP.contractPlattform.isValidNewContractRequestEntry = function() {
    var isValid = true;
    var productName = $('.js-product-description');
    var productCount = $('.js-request-entry-product-count');

    if (!productName.val()) {
        $('.js-request-validation-entry-description .error').removeClass("hide");
        isValid = false;
    } else {
        $('.js-request-validation-entry-description .error').addClass("hide");
    }

    if (!productCount.val()) {
        $('.js-request-validation-new-entry-count .error').removeClass("hide");
        isValid = false;
    } else {
        $('.js-request-validation-new-entry-count .error').addClass("hide");
    }

    return isValid;
};

KMVP.contractPlattform.isValidContractRequest = function() {
    var isValid = true;
    var requestFromDate = $('.js-request-validation-from .js-datepicker');
    var requestToDate = $('.js-request-validation-to .js-datepicker');
    var contractRequestEntry = $('.js-contract-request-entry');

    if (!requestFromDate.val()) {
        $('.js-request-validation-from .error').removeClass("hide");
        isValid = false;
    } else {
        $('.js-request-validation-from .error').addClass("hide");
    }

    if (!requestToDate.val()) {
        $('.js-request-validation-to .error').removeClass("hide");
        isValid = false;
    } else {
        $('.js-request-validation-to .error').addClass("hide");
    }

    $('.js-contract-request-entry').each(function() {
        if (!$(this).find('.js-article-count').val()) {
            $(this).find(".control-group .error").removeClass("hide");
            isValid = false;
        } else {
            $(this).find(".control-group .error").addClass("hide");
        }
    });

    return isValid;
};

KMVP.contractPlattform.bindUnitSelector = function() {
    // add click event for value change
    $('.js-qty-unit').on('change', function(e) {
        var $this = $(this),
            contractid = $this.data("contractid"),
            selected = $this.val(),
            quantityInput = $this.closest('.control-group').find('.js-cp-calloff-quantity'),
            standardPlaceholder = quantityInput.data('default-placeholder'),
            fixedPlaceholder = quantityInput.data('fixed-length-placeholder');

        if (selected == 'FIXEDLENGTH') {
            KMVP.contractPlattform.displayFixedLengthInput(contractid);
            quantityInput.attr('placeholder', fixedPlaceholder);
        } else {
            KMVP.contractPlattform.hideFixedLengthInput(contractid);
            quantityInput.attr('placeholder', standardPlaceholder);
        }
    });
};

KMVP.contractPlattform.displayFixedLengthInput = function(contractid) {
    var inputContainer = $('.js-fixed-length-input-' + contractid);
    if (inputContainer.hasClass('hide')) {
        inputContainer.removeClass('hide');
    }
};

KMVP.contractPlattform.hideFixedLengthInput = function(contractid) {
    var inputContainer = $('.js-fixed-length-input-' + contractid);
    if (!inputContainer.hasClass('hide')) {
        inputContainer.addClass('hide');
        inputContainer.children('input[name="fixedLengthPieces"]').val('');
    }
};

KMVP.contractPlattform.expandSingletonContract = function() {
    if ($('.js-singletonContractId').val()) {
        $(".js-collapse-symbol[aria-expanded=false]").trigger('click');
    }
};

$(document).ready(function() {

    // TODO: add ckeck for contract pages (id from  contract header / implemented by thomas)

    with (KMVP.contractPlattform) {
        initPageEvents();
        initActiveContractIds();
        getActiveContractsList();
        getLatestOrders();
        getOnlineQuotes();
        getExpiredContracts();
        getContractEntriesForFollowUp();
        expandSingletonContract();

        bindContractAddToCartForm();
        bindUnitSelector();
    }

});